import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Button, useToast, HStack, Badge, Heading } from "@chakra-ui/react";
import GRLCPlacementEditor from "./GRLCPlacementEditor";
import Navbar from "./Navbar";
import { getDeal } from "./services/MrcaiAPI";

const GRLCPlacementEditorPage = () => {
  const { productCode, dealId } = useParams();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        setDeal(await getDeal(dealId));
      } catch (err) {
        toast({ title: "Failed to load deal", description: err.message, status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchDeal();
  }, [productCode, dealId, toast]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

      {/* Version indicator and switch */}
      <Box p={4} bg="gray.50" borderBottom="1px" borderColor="gray.200">
        <HStack justify="space-between">
          <HStack>
            <Badge colorScheme="gray" fontSize="md" px={3} py={1}>
              Original Version
            </Badge>
            <Heading size="sm" color="gray.700">
              8,434 lines • Single file
            </Heading>
          </HStack>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={() => navigate(`/product/${productCode}/deal/${dealId}/placement-v2`)}
          >
            Try Refactored Version →
          </Button>
        </HStack>
      </Box>

      {/* Deals no longer carry placement terms: editable but not saveable */}
      <GRLCPlacementEditor contractInstance={deal} productTemplate={null} recordType="deal" />

    </Box>
  );
};

export default GRLCPlacementEditorPage;
